import { useQuery, UseQueryResult } from "react-query";
import { getBanners } from "./fetch";
import { Banner } from "./types";

export const useBanners = (): UseQueryResult<Banner[]> => {
  return useQuery("getBanners", () => getBanners());
};
